<script>
import VSelect from '@/components/Common/VSelect';
import VSelectSearch from '@/components/Common/VSelectSearch';
import VInput from '@/components/Common/VInput';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { http } from '@/plugins/http';

const SETTINGS_SLIDER = {
  dotSize: 20,
  dotStyle: {
    backgroundColor: '#FFF',
    border: '7px solid #95CA51',
  },
  railStyle: {
    backgroundColor: '#fff',
  },
  processStyle: {
    border: '1px solid #95CA51',
    backgroundColor: '#95CA51',
  },
};

export default {
  components: {
    VSelect,
    VSelectSearch,
    VInput,
    VueSlider,
  },
  emit: ['change-count'],
  props: {
    filterData: {
      type: Object,
      default: () => ({}),
    },
    urlGetData: {
      type: String,
      default: '',
    },
    urlSetFilter: {
      type: String,
      default: '',
    },
    autoOrderUrl: {
      type: String,
      default: '',
    },
    serviceBookingUrl: {
      type: String,
      default: '',
    },
    tabActive: {
      type: String,
      default: '',
    },
    newBrands: {
      default: [],
    },
    countUsedAuto: {
      type: Number,
    },
    city: {
      type: String,
      default: '/',
    },
  },
  SETTINGS_SLIDER,

  data() {
    return {
      brand: null,
      isParallelnyi: false,
      model: null,
      brands: [],
      models: [],
      serviceBookingUrl: this.serviceBookingUrl,
      newBrands: this.newBrands,
      priceMin: this.filterData.price_min,
      priceMax: this.filterData.price_max,
      sliderValue: [this.filterData.price_min, this.filterData.price_max],
      timer: null,
      countUsedAuto: this.countUsedAuto,
    };
  },

  watch: {
    brand() {
      this.models = [];
      this.getCarsData(this.ajaxUrl());
    },
    model() {
      this.getCarsData(this.ajaxUrl());
    },

    priceMin(newValue) {
      this.sliderValue = [newValue, this.sliderValue[1]];
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getCarsData(this.ajaxUrl());
      }, 300);
    },

    priceMax(newValue) {
      this.sliderValue = [this.sliderValue[0], newValue];
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getCarsData(this.ajaxUrl());
      }, 300);
    },

    sliderValue(newValue) {
      if (this.sliderValue[0] !== this.priceMin) {
        this.priceMin = this.sliderValue[0];
      }
      if (this.sliderValue[1] !== this.priceMax) {
        this.priceMax = this.sliderValue[1];
      }
    },
  },

  methods: {
    changeTab(tab) {
      this.$emit('change-tab', tab);
    },
    urlParams() {
      let params = '';

      this.brand?.forEach(brand => {
        params += `&brands[]=${brand.id}`;
      });

      this.model?.forEach(model => {
        params += `&models[]=${model.id}`;
      });

      if (this.priceMin) {
        params += `&price_min=${this.priceMin}`;
      }

      if (this.priceMax) {
        params += `&price_max=${this.priceMax}`;
      }

      params = params.slice(1, params.length);
      return `?${encodeURI(params)}`;
    },

    ajaxUrl() {
      return this.urlGetData + this.urlParams();
    },

    setFilter() {
      document.location.href = `${document.location.origin}/${this.urlSetFilter}${this.urlParams()}`;
    },

    getCarsData(param) {
      http.get(`/filter/${param}`).then(data => {
        if (data.data.models) {
          this.models = data.data.models;
        }
        this.$emit('change-count', data.data);
      });
    },
  },

  created() {
    for (let key in this.filterData.brandsVue) {
      this.brands.push(this.filterData.brandsVue[key]);
    }
  },
};
</script>
<template>
  <div>
    <div
      class="flex flex-col xl:flex-row xl:flex-wrap p-3.5 xl:p-8 rounded-big-brand xl:rounded-big-brand bg-white xl:space-x-5 md:space-y-4 space-y-2 xl:space-y-0 w-full"
    >
      <div
        class="flex flex-row overflow-x-auto gap-[25px] xl:w-full xl:ml-[20px] ml-[0px] whitespace-nowrap pb-[20px]"
      >
        Официальный дилер
      </div>
      <div
        class="flex flex-row overflow-x-auto gap-[25px] xl:w-full xl:ml-[20px] ml-[0px] whitespace-nowrap pb-[20px]"
      >
        <div class="grid 2xl:grid-cols-9 lg:grid-cols-5 sm:grid-cols-4 grid-cols-2 items-center w-full justify-start gap-[10px]">
          <a
            v-for="brand in newBrands"
            :href="`${city}cars/new/${brand.url}`"
            class="flex items-center h-[68px] px-[5px] py-[10px] w-full custom-border"
          >
            <div class="flex flex-row gap-[10px]">
              <div class="flex justify-center items-center max-w-[62px] ">
                <img :src="`/uploads/brand/${brand.logo}`"
                  alt="" />
              </div>
              <div class="flex flex-col">
                <div class="font-roboto text-gray-800 font-medium text-base">
                  {{ brand.name }}
                </div>
                <div class="text-gray-600 text-base">{{ brand.count }}</div>
              </div>
            </div>
          </a>

          <a
            href="./cars/used/"
            class="2xl:col-span-1 lg:col-span-2 col-span-1 flex items-center h-[68px] px-[5px] py-[10px] w-full custom-border"
          >
            <div class="text-gray-800 text-base mr-3 whitespace-pre-line">Авто с пробегом</div>
            <div
              class="text-white bg-green py-1.5 px-2.5 text-xs font-medium filter__counter rounded-brand"
            >
              {{ countUsedAuto }}
            </div>
          </a>
          <a
            class="lg:col-span-1 md:col-span-4 sm:col-span-4 col-span-2 button button_orange-brand leading-4 flex h-12 w-full md:w-auto items-center justify-center text-center text-base hover:bg-blue-light hover:text-black"
            :href="serviceBookingUrl"
          >
            Запись на сервис <br /> on-line
          </a>
        </div>
      </div>
      <div
        class="flex flex-row overflow-x-auto gap-[25px] xl:w-full xl:ml-[20px] ml-[0px] whitespace-nowrap pb-[20px]"
      >
        <div
          class="text-gray-800 text-base opacity-[.85] cursor-pointer"
          :class="{
            ' border-b-2 border-green opacity-[1]': tabActive === 'new',
          }"
          @click="changeTab('new')"
        >
          Новые
        </div>
        <div
          class="text-gray-800 text-base opacity-[.85] cursor-pointer"
          :class="{
            ' border-b-2 border-green opacity-[1]': tabActive === 'mileage',
          }"
          @click="changeTab('mileage')"
        >
          С пробегом
        </div>
        <!-- <div
          class="text-gray-800 text-base opacity-[.85] cursor-pointer"
          v-if="isParallelnyi"
          :class="{
            ' border-b-2 border-green opacity-[1]':
              tabActive === 'parallelnyi-import',
          }"
          @click="changeTab('parallelnyi-import')"
        >
          Параллельный импорт
        </div> -->
      </div>
      <div
        class="flex flex-col md:space-x-4 space-y-2 md:space-y-0 md:flex-row"
      >
        <div class="md:w-1/2 xl:w-56">
          <v-select-search
            v-model="brand"
            :options="brands"
            theme="white"
            placeholder="Выберите марку авто"
            class="md:w-full xl:w-56"
            multiple
          />
        </div>
        <div class="md:w-1/2">
          <v-select-search
            v-model="model"
            :options="models"
            theme="white"
            placeholder="Выберите модель авто"
            class="md:w-full xl:w-56"
            label="text"
            multiple
            :disabled="!brand"
            :class="{ 'opacity-60': !brand }"
          />
        </div>
      </div>
      <div>
        <div
          class="relative grid grid-cols-2 md:flex gap-4 xl:gap-0 xl:space-x-3 items-center"
        >
          <v-input
            v-model="priceMin"
            theme="white"
            class="bg-white rounded-brand md:w-full xl:w-44"
            prefix="от"
            sufix=" руб."
            format="price"
            classes-input="!text-green"
            :min="filterData.price_min"
            :max="filterData.price_max"
            :lazy="true"
          />
          <div
            class="absolute xl:relative top-1/2 left-1/2 xl:left-0 xl:top-0 -translate-y-1/2 -translate-x-1/2 xl:translate-x-0 xl:translatey-y-0 w-1.5 xl:w-3.5 h-px bg-gray-600"
          ></div>
          <v-input
            v-model="priceMax"
            theme="white"
            class="bg-white rounded-brand md:w-full xl:w-44"
            prefix="до"
            sufix=" руб."
            format="price"
            classes-input="!text-green"
            :min="filterData.price_min"
            :max="filterData.price_max"
            :lazy="true"
          />
        </div>
        <vue-slider
          v-model="sliderValue"
          :min="this.filterData.price_min"
          :max="this.filterData.price_max"
          :tooltip="'none'"
          :interval="1"
          :dot-size="$options.SETTINGS_SLIDER.dotSize"
          :dot-style="$options.SETTINGS_SLIDER.dotStyle"
          :rail-style="$options.SETTINGS_SLIDER.railStyle"
          :process-style="$options.SETTINGS_SLIDER.processStyle"
          class="mt-5 md:mt-6 mx-3"
          :enableCross="false"
        />
      </div>
      <div
        class="hidden button button_green lg:flex items-center justify-center flex-1 text-base h-12 hover:text-black hover:bg-blue-light"
        @click="setFilter"
      >
        Подобрать
      </div>
    </div>

    <div
      class="lg:hidden button button_green w-full text-base h-10 md:h-15 mt-5 hover:text-black hover:bg-blue-light"
      @click="setFilter"
    >
      Подобрать
    </div>

    <!-- <a
      class="lg:hidden button button_green mt-5 w-full items-center justify-center text-base h-10 md:h-15 hover:text-black hover:bg-blue-light"
      :href="autoOrderUrl"
    >
      Авто на заказ
    </a> -->
    <!-- <a
      class="button button_orange-brand mt-5 h-10 w-full items-center justify-center text-base hover:bg-blue-light hover:text-black md:h-15 hidden"
      :href="serviceBookingUrl"
    >
      Запись на сервис on-line
    </a> -->
  </div>
</template>

<style scoped>
.custom-border {
  border: 1px solid #f5f6f8 !important;
  border-radius: 7px;
}
</style>
